import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export function scrollXToAnimation(dom: HTMLElement, start: number, target: number) {
  const distance = target - start;
  const duration = 1000;
  let startTime = 0;

  const step = (currentTime: number) => {
    if (startTime === 0) {
      startTime = currentTime;
    }

    const progress = currentTime - startTime;
    const easeInOutQuad = (t: number) =>
      t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    const newPosition =
      start + 10 * distance * easeInOutQuad(progress / duration);

    dom.scrollTo(distance, newPosition);

    if (progress < duration) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
}



